import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/auth/ProtectedRoute";
import Login from "components/auth/Login";
// Dashboard imports (admin only)
import ExecutiveSalesOverviewDashboard from "pages/executive-sales-overview-dashboard";
import CompanyPerformanceAnalyticsDashboard from "pages/company-performance-analytics-dashboard";
import RealTimeOperationsMonitoringDashboard from "pages/real-time-operations-monitoring-dashboard";
// Data entry interface (user access)
import DataEntryAndValidationInterface from "pages/data-entry-and-validation-interface";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes - role-based access */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute requiredRole="admin" fallbackComponent={
                <ProtectedRoute>
                  <DataEntryAndValidationInterface />
                </ProtectedRoute>
              }>
                <ExecutiveSalesOverviewDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Admin-only dashboard routes */}
          <Route 
            path="/executive-sales-overview-dashboard" 
            element={
              <ProtectedRoute requiredRole="admin">
                <ExecutiveSalesOverviewDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/company-performance-analytics-dashboard" 
            element={
              <ProtectedRoute requiredRole="admin">
                <CompanyPerformanceAnalyticsDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/real-time-operations-monitoring-dashboard" 
            element={
              <ProtectedRoute requiredRole="admin">
                <RealTimeOperationsMonitoringDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* User accessible route */}
          <Route 
            path="/data-entry-and-validation-interface" 
            element={
              <ProtectedRoute>
                <DataEntryAndValidationInterface />
              </ProtectedRoute>
            } 
          />
          
          {/* Catch all route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;